import classes from "./Footer.module.css";
import { faFacebook, faInstagram } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
const Footer = () => {
  return (
    <div className={classes.footer}>
      <div> &copy; HUNGRYBOX DHAKA &trade; </div>
      <div className={classes.icon}>
        <a href="https://www.facebook.com/Hungrybox-Dhaka-108123931635827/?ref=pages_you_manage">
          <FontAwesomeIcon
            icon={faFacebook}
            size="2x"
            color="white"
          ></FontAwesomeIcon>
        </a>
      </div>

      <div className={classes.icon}>
        <a href="https://www.instagram.com/hungryboxdhaka">
          <FontAwesomeIcon
            icon={faInstagram}
            size="2x"
            color="white"
          ></FontAwesomeIcon>
        </a>
      </div>
    </div>
  );
};
export default Footer;
